export class BaseDto {
  id?: number;
  name?: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  deletedAt?: Date | string;
  updatedBy?: string;
  createdBy?: string;
}
